import { useEffect } from 'react'

interface PasteHandlerProps {
  enabled: boolean;
  onPaste: (file: File) => Promise<void>;
}

export const PasteHandler = ({ enabled, onPaste }: PasteHandlerProps) => {
  useEffect(() => {
    const handlePaste = async (event: ClipboardEvent) => {
      const items = event.clipboardData?.items
      if (!items) return

      for (const item of items) {
        if (item.type.indexOf('image') !== -1) {
          const file = item.getAsFile()
          if (file) {
            event.preventDefault()
            await onPaste(file)
          }
        }
      }
    }

    if (enabled) {
      document.addEventListener('paste', handlePaste)
      return () => {
        document.removeEventListener('paste', handlePaste)
      }
    }
  }, [enabled, onPaste])

  return null
}